import { c as _c } from "react/compiler-runtime";
import { getCountryNameFromCode } from '@onefootprint/core';
import { useTranslation } from 'react-i18next';
import { markContinueOnMobile } from '@/idv2/features/idv-to-idv2/store-utils';
import { useFootprint } from '@/idv2/hooks/use-footprint';
import type { CaptureKind } from '../../../types';
import { DOC_REQUEST_KIND } from '../../../types';
import { useNonIdDocMachine } from '../../context/non-id-doc-context';
import DocumentPromptView from './document-prompt-view';
import useGuidelines from './hooks/use-guidelines';
import useTitleAndDescription from './hooks/use-title-and-description';
const DocumentPrompt = () => {
  const $ = _c(25);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.non-id-doc.pages.document-prompt"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const [state, dispatch] = useNonIdDocMachine();
  const footprint = useFootprint();
  const {
    device,
    hasBadConnectivity,
    requirement,
    obConfigSupportedCountries,
    config,
    allowPdf
  } = state.context;
  const hasPreferUploadSettings = requirement.uploadSettings === "prefer_upload";
  const isMobile = device.type === "mobile";
  const {
    kind: documentRequestKind
  } = requirement.config;
  let t1;
  if ($[1] !== config || $[2] !== documentRequestKind) {
    t1 = {
      docKind: documentRequestKind,
      config
    };
    $[1] = config;
    $[2] = documentRequestKind;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const guidelines = useGuidelines(t1);
  const {
    title,
    description
  } = useTitleAndDescription(requirement.config);
  let alertMessage;
  if (obConfigSupportedCountries && obConfigSupportedCountries.length === 1 && documentRequestKind === DOC_REQUEST_KIND.proofOfAddress) {
    let t2;
    if ($[4] !== obConfigSupportedCountries[0] || $[5] !== t) {
      t2 = t(_temp, {
        country: getCountryNameFromCode(obConfigSupportedCountries[0])
      });
      $[4] = obConfigSupportedCountries[0];
      $[5] = t;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    alertMessage = t2;
  }
  let t2;
  if ($[7] !== dispatch) {
    t2 = payload => {
      dispatch({
        type: "receivedDocument",
        payload
      });
    };
    $[7] = dispatch;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleComplete = t2;
  let t3;
  if ($[9] !== footprint.navigation) {
    t3 = () => {
      markContinueOnMobile();
      footprint.navigation.forward();
    };
    $[9] = footprint.navigation;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleContinueOnMobile = t3;
  let t4;
  if ($[11] !== dispatch) {
    t4 = () => {
      dispatch({
        type: "startImageCapture"
      });
    };
    $[11] = dispatch;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleTakePhoto = t4;
  const uploadFirst = documentRequestKind === DOC_REQUEST_KIND.custom ? hasPreferUploadSettings : documentRequestKind !== DOC_REQUEST_KIND.proofOfSsn;
  let t5;
  if ($[13] !== alertMessage || $[14] !== allowPdf || $[15] !== description || $[16] !== guidelines || $[17] !== handleComplete || $[18] !== handleContinueOnMobile || $[19] !== handleTakePhoto || $[20] !== hasBadConnectivity || $[21] !== isMobile || $[22] !== title || $[23] !== uploadFirst) {
    t5 = <DocumentPromptView title={title} description={description} guidelines={guidelines} alertMessage={alertMessage} isMobile={isMobile} uploadFirst={uploadFirst} allowPdf={allowPdf} hasBadConnectivity={hasBadConnectivity} onComplete={handleComplete} onTakePhoto={handleTakePhoto} onContinueOnMobile={handleContinueOnMobile} />;
    $[13] = alertMessage;
    $[14] = allowPdf;
    $[15] = description;
    $[16] = guidelines;
    $[17] = handleComplete;
    $[18] = handleContinueOnMobile;
    $[19] = handleTakePhoto;
    $[20] = hasBadConnectivity;
    $[21] = isMobile;
    $[22] = title;
    $[23] = uploadFirst;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  return t5;
};
export default DocumentPrompt;
function _temp($) {
  return $["single-country-alert"];
}